export const REQUEST_DETAILS = 'REQUEST_DETAILS';